export default __webpack_public_path__ + "static/media/TW.dd21f8ff.svg";